import Link from 'next/link';
import styled from 'styled-components';
import {
  cssSpacing,
  EncoreComponentProps,
  NavBarListItem,
  Type,
} from '@spotify-internal/encore-web';

const StyledAnchorType = styled(Type)`
  &[href]:focus::after {
    inline-size: ${cssSpacing('tighter-2', '16px')};
  }

  &::after {
    inline-size: ${cssSpacing('tighter-2', '16px')};
  }
`;

const StyledNavBarListItem = styled(NavBarListItem)`
  cursor: pointer;
`;

function NavLink({
  href,
  ...props
}: EncoreComponentProps<typeof Link, typeof Type>) {
  return (
    <Link href={href} passHref legacyBehavior>
      <StyledAnchorType as="a" {...props} />
    </Link>
  );
}

export function NavBarListItemAsLink(
  props: EncoreComponentProps<typeof NavBarListItem, typeof Link>,
) {
  return <StyledNavBarListItem {...props} component={NavLink} />;
}
